import React, { FunctionComponent } from 'react';
import cn from 'classnames';

import '@styles/typography.scss';

interface TypographyProps {
  variant:
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'inherit'
    | 'overline'
    | 'subtitle1'
    | 'subtitle2'
    | 'body1'
    | 'body2'
    | 'button'
    | 'caption'
    | 'currency';
  size: 'xs' | 'sm' | 'rg' | 'lg' | 'x' | '2x' | '3x' | 'xl';
  colour?: 'primary' | 'primary-line' | 'alternative' | 'error';
  className?: String;
  weight?: 'bold' | 'semi-bold' | 'medium' | 'normal';
}

// Defining the HTML tag that the component will support
const variantsMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  inherit: 'p',
  overline: 'span',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p',
  button: 'span',
  caption: 'span',
  currency: 'span',
};

const Typography: FunctionComponent<TypographyProps> = ({
  variant,
  colour = 'primary',
  size,
  children,
  className,
  weight,
  ...rest
}) => {
  const Component: any = variant ? variantsMapping[variant] : 'p';
  return (
    <Component
      className={cn({
        [`${className}`]: className,
        [`typography__${variant}`]: variant,
        [`typography__${colour}`]: colour,
        [`typography__text-${size}`]: size,
        [`typography--${weight}`]: weight,
      })}
      {...rest}
    >
      {variant === 'currency' ? `£${children}` : children}
    </Component>
  );
};

export default Typography;
